/**
 * Created by root on 8/30/15.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var BaseController = require('web-agent-assets-js/BaseController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');

    window.lpTag.AMSStatics = window.lpTag.AMSStatics || {};

    var model;
    var amsCommunicationChannel = webAgentStatics.COMMUNICATION_CHANNELS.AMS;
    // this object contains the registry of all object that needed to be tracked.
    var trackingList = {};

    function AMSSubscriptionsManagerController(options) {
        if (options) {
            if (options.model) {
                model = options.model;
            }
        }

        // run until stopped, every 1 sec.
        // the update of the ui will be applied only if the data is changed. (dirty checking).
        if (window.App.timerManager.registerTimer) {
            this.timer = window.App.timerManager.registerTimer({
                context: this,
                callback: _syncTrackedConversations,
                interval: 2
            });
        }

        lpTag.WebAgent.channel.register(amsCommunicationChannel.name, amsCommunicationChannel.events.onExConversationNotification, this.ExtraConversationNotificationEventHandler.bind(this));
    }

    var lpAMSSubscriptionsManagerController = BaseController.extend(AMSSubscriptionsManagerController);

    /**
     * the dictionary of the subscriptions.
     * @type {{}}
     */
    lpAMSSubscriptionsManagerController.prototype.subscriptions = {};

    /**
     *
     * @param query - the query for the subscription.
     * @param {?String}  query.brandId - the brand id
     * @param {?TimeStamp} query.maxLastUpdatedTime - the maximum TS the Last update occur
     * @param {?TimeStamp} query.minLastUpdatedTime - the minimum TS the last update occur
     * @param {(?Array<string>|string)} query.agentIds - a list of agent id's or one agent id.
     * @param {?String} query.consumerId - the consumer id
     * @param {?TimeStamp} query.maxETTR - the maximum effective ttr time.
     * @param {?Array<string>} query.convState   - a list of conversation states
     * @param {Object} settings - list of options for the data model.
     * @param {String} settings.modelPath - the path to save the data of the subscriptions.
     * @param {String} settings.modelOnlyLatestConversation - the path to save the data of the subscriptions.
     * @param {String} settings.isDirtyModelPath - the path to save the data changed flag.
     * @param {Object} settings.conversationPreProcessHandlers - invoked before each conversation is processed and is in the model.
     * @param {Function} settings.conversationPreProcessHandlers.UPSERT - invoked for UPSERT notifications.
     * @param {Function} settings.conversationPreProcessHandlers.DELETE - invoked for DELETE notifications.
     * @param {Object} settings.conversationPostProcessHandlers - invoked after each conversation is processed and is in the model.
     * @param {Function} settings.conversationPostProcessHandlers.UPSERT - invoked for UPSERT notifications.
     * @param {Function} settings.conversationPostProcessHandlers.DELETE - invoked for DELETE notifications.
     * @param {Function} settings.onNotificationPostProcess - invoked after all conversations has been processed.
     * @param {Function} callback  - the callback for the operations -> return the subscriptionId in the response.
     */
    lpAMSSubscriptionsManagerController.prototype.subscribe = function (query, settings, callback) {
        var self = this;
        var req = lpUtils.cloneObject(query);
        if (!req.brandId && model) {
            req.brandId = model.get('account');
        }
        req.success = function (result) {
            self.subscriptions[result.subscriptionId] = {
                settings: lpUtils.cloneObject(settings),
                query: query,
                notificationIndex: 0,
                conversations: {}
            };
            invokeCallback(null, result);
        };
        req.error = function (err) {
            self.logger.error('Request subscription failed.');
            self.logger.graph({name: 'subscribeExConversationsError'});
            invokeCallback(err);
        };

        lpTag.WebAgent.amsConnectionController.amsClient.subscribeConversations(req);

        function invokeCallback(err, result) {
            if (_.isFunction(callback)) {
                callback(err, result);
            }
        }
    };

    /**
     * un-subscribe from a query in the ams server.
     * @param {String} subscriptionId - the subscription id to unscubscribe from
     * @param {Boolean} removeModelData - boolean flag, indicating if we want to remove all the data from the model.
     */
    lpAMSSubscriptionsManagerController.prototype.unsubscribe = function (subscriptionId, removeModelData) {

        try {
            lpTag.WebAgent.amsConnectionController.amsClient.unsubscribeConversations({
                subscriptionId: subscriptionId
            });
        } catch (ex) {
            this.logger.error(ex.message, 'unsubscribe', ex);
        }

        if (this.subscriptions.hasOwnProperty(subscriptionId)) {
            var subscription = this.subscriptions[subscriptionId];

            // remove the subscription from the model
            if (!!removeModelData) {
                if(subscription && subscription.settings && subscription.settings.modelPath){
                    model.removeKey(subscription.settings.modelPath);
                }
            }

            // clear the cached subscription
            for (var item in subscription) {
                delete subscription[item];
            }
            delete this.subscriptions[subscriptionId];
        }

        if (trackingList.hasOwnProperty(subscriptionId)) {
            for (var conversationId in trackingList[subscriptionId]) {
                this.stopTrackingConversationDetails(subscriptionId, conversationId);
            }
            trackingList[subscriptionId] = null;
            delete trackingList[subscriptionId];
        }
    };

    /**
     * Update existing subscription with additional query parameneter
     * In order to remove param update it with undefined
     * @param {String} subscriptionId
     * @param {Object} query
     */
    lpAMSSubscriptionsManagerController.prototype.updateSubscription = function (subscriptionId, query) {
        if(this.subscriptions[subscriptionId]) {
            _.extend(this.subscriptions[subscriptionId].query, query);
            lpTag.WebAgent.amsConnectionController.amsClient.updateConversationsSubscription(_.extend({}, this.subscriptions[subscriptionId].query, {subscriptionId: subscriptionId}));
        }
    };

    /**
     * Handling the event when we have an update for a conversation.
     * @param {Object} evt
     * @param {Array<Conversation>} evt.changes
     * @param {String} evt.subscriptionId
     * @constructor
     */
    lpAMSSubscriptionsManagerController.prototype.ExtraConversationNotificationEventHandler = function (evt) {

        var subscription, subscriptionSettings, isFirstEvent, updateType, conversationData,
            conversationUpdate, conversationResourcesResolvedCallback, updateIndex, notificationKey;

        var subscriptionId = evt.subscriptionId;
        var conversationUpdates = evt.changes;

        if (evt && subscriptionId && this.subscriptions.hasOwnProperty(subscriptionId) &&
            conversationUpdates && conversationUpdates.constructor === Array) {

            subscription = this.subscriptions[subscriptionId];
            subscriptionSettings = subscription.settings;
            isFirstEvent = subscription.notificationIndex === 0;
            notificationKey = 'notification_' + subscription.notificationIndex;

            subscription.notificationIndex++;

            if (conversationUpdates.length) {

                for (updateIndex = 0; updateIndex < conversationUpdates.length; updateIndex++) {
                    conversationUpdate = conversationUpdates[updateIndex];
                    conversationData = conversationUpdate.result;
                    updateType = conversationUpdate.type;

                    if (subscriptionSettings.conversationPreProcessHandlers && _.isFunction(subscriptionSettings.conversationPreProcessHandlers[updateType])) {
                        // fire the pre process handler
                        subscriptionSettings.conversationPreProcessHandlers[updateType].call(this, conversationData);
                    }

                    if (conversationData) {
                        // create a callback for the resolve operation.
                        conversationResourcesResolvedCallback = _.bind(
                            _onConversationResourcesResolved, this, conversationData, subscriptionId, updateType, conversationUpdates, notificationKey, isFirstEvent);

                        // resolving the resources needed for the conversation. (profiles)
                        // the callback will run after all needed resources will be loaded.
                        _resolveConversationResources(conversationData, conversationResourcesResolvedCallback);
                    }
                }

            } else {

                // in case the conversations list is empty, we still want to start the flow, this will fix LE-41077 Issue.
                if (isFirstEvent && subscriptionSettings.modelPath) {
                    model.modify(subscriptionSettings.modelPath, {});
                    if (subscriptionSettings.isDirtyModelPath) {
                        model.modify(subscriptionSettings.isDirtyModelPath, true);
                    }
                }

                // send indication for end of notification processing
                if (_.isFunction(subscriptionSettings.onNotificationPostProcess)) {
                    subscriptionSettings.onNotificationPostProcess.call(this, [], isFirstEvent);
                }
            }
        }
    };

    lpAMSSubscriptionsManagerController.prototype.trackConversationDetails = function (subscriptionId, conversationId) {

        // creating an entrance for the subscription is not exists
        if (!trackingList.hasOwnProperty(subscriptionId)) {
            trackingList[subscriptionId] = {};
        }
        if (!trackingList[subscriptionId].hasOwnProperty(conversationId)) {
            // adding to the tracking and modifying the model when needed.
            trackingList[subscriptionId][conversationId] = null;
        }
    };

    lpAMSSubscriptionsManagerController.prototype.stopTrackingConversationDetails = function (subscriptionId, conversationId) {
        if (trackingList.hasOwnProperty(subscriptionId) && trackingList[subscriptionId].hasOwnProperty(conversationId)) {
            delete trackingList[subscriptionId][conversationId];
        }
    };


    /**
     * a callback to handle conversations data after all dependent resources has been resolved.
     *
     * @param conversationData - the conversation data to save.
     * @param subscriptionId - the subscription ID
     * @param notificationType - the update type, e.g. UPSERT, DELETE
     * @param conversationUpdates - raw conversation updates array
     * @param notificationKey - unique identifier for the current notification
     * @returns {Function}
     */
    function _onConversationResourcesResolved(conversationData, subscriptionId, notificationType, conversationUpdates, notificationKey, isFirstEvent) {

        var subscription, subscriptionSettings, conversationId, targetModelPath;

        if (conversationData && this.subscriptions.hasOwnProperty(subscriptionId)) {

            conversationId = conversationData.convId;
            subscription = this.subscriptions[subscriptionId];
            subscriptionSettings = subscription.settings;

            if (!subscription.conversations[conversationData.convId]) {
                subscription.conversations[conversationData.convId] = {
                    lastUpdateTime: conversationData.lastUpdateTime
                };
            }

            if ( !(conversationData.lastUpdateTime && subscription.conversations[conversationData.convId].lastUpdateTime) ){
                this.logger.error('subscription conversation does not have lastUpdateTime.');
            }
            if (conversationData.lastUpdateTime < subscription.conversations[conversationData.convId].lastUpdateTime) {
                return;
            }

            subscription.conversations[conversationData.convId].lastUpdateTime = conversationData.lastUpdateTime;

            subscription.lastUpdate = Date.now();

            // setting the agent and the consumer profile
            _setCustomProperties(conversationData);

            if (subscriptionSettings.modelPath) {

                targetModelPath = subscriptionSettings.modelPath + '.' + conversationId;

                // modify the model.
                switch (notificationType) {
                    case lpAMSController.NOTIFICATION_TYPES.UPSERT:
                        // add the tracking here if needed.
                        if (subscriptionSettings.trackActiveConversations) {
                            this.trackConversationDetails(subscriptionId, conversationId);
                        }
                        // saving to the model
                        model.set(targetModelPath, conversationData);
                        break;
                    case lpAMSController.NOTIFICATION_TYPES.DELETE:
                        // remove the tracking in here.
                        if (subscriptionSettings.trackActiveConversations) {
                            this.stopTrackingConversationDetails(subscriptionId, conversationId);
                        }
                        // removing from the model
                        model.removeKey(targetModelPath);
                        break;
                }
            }

            // mark the data as dirty.
            if (subscriptionSettings.isDirtyModelPath) {
                model.modify(subscriptionSettings.isDirtyModelPath, true);
            }

            // fire the callback for the post process.
            if (subscriptionSettings.conversationPostProcessHandlers &&
                _.isFunction(subscriptionSettings.conversationPostProcessHandlers[notificationType])) {
                subscriptionSettings.conversationPostProcessHandlers[notificationType].call(this, conversationData);
            }


            if (_.isFunction(subscriptionSettings.onNotificationPostProcess)) {

                _collectProcessedConversationData.call(this, notificationType, conversationData, subscription, notificationKey);

                if (subscription[notificationKey].conversationUpdatesCount === conversationUpdates.length) {
                    // processing is finished, invoke the appropriate callback and clean the cached map
                    subscriptionSettings.onNotificationPostProcess.call(this, _.values(subscription[notificationKey].processedConversationsMap), isFirstEvent);
                    _clearProcessedConversationData.call(this, subscription, notificationKey);
                }
            }
        }
    }


    function _collectProcessedConversationData(notificationType, conversationData, subscription, notificationKey) {

        var conversationId = conversationData.convId;

        _resetProcessedConversationData.call(this, subscription, notificationKey);

        // update the counter to keep track of the notification batch
        subscription[notificationKey].conversationUpdatesCount++;

        // update the cached map
        switch (notificationType) {
            case lpAMSController.NOTIFICATION_TYPES.UPSERT:
                subscription[notificationKey].processedConversationsMap[conversationId] = conversationData;
                break;
            case lpAMSController.NOTIFICATION_TYPES.DELETE:
                delete subscription[notificationKey].processedConversationsMap[conversationId];
                break;
        }
    }

    function _resetProcessedConversationData(subscription, notificationKey) {
        var notificationData;
        if (!subscription[notificationKey]) {
            subscription[notificationKey] = {};
        }
        notificationData = subscription[notificationKey];
        if (!notificationData.processedConversationsMap) {
            notificationData.processedConversationsMap = {};
        }
        if (!notificationData.conversationUpdatesCount && notificationData.conversationUpdatesCount !== 0) {
            // use a dedicated counter and don't rely on the conversation update iteration index,
            // as the resolved callbacks are called asynchronously
            notificationData.conversationUpdatesCount = 0;
        }
    }

    function _clearProcessedConversationData(subscription, notificationKey) {
        var i,
            notificationData = subscription[notificationKey];
        if (typeof notificationData === 'undefined') {
            return;
        }
        if (notificationData.processedConversationsMap) {
            for (i = 0; i < notificationData.processedConversationsMap; i++) {
                delete notificationData.processedConversationsMap[i];
            }
            delete notificationData.processedConversationsMap;
        }
        if (typeof notificationData.conversationUpdatesCount !== 'undefined') {
            delete notificationData.conversationUpdatesCount;
        }
    }

    /**
     * Resolving the conversation needed dependencies for proper working with the conversation,
     * loading the profiles.
     * @param conversationData - the conversation data to extract the dependencies.
     * @param callback - the callback to run when all dependencies are resolved.
     */
    function _resolveConversationResources(conversationData, callback) {

        // for now, we are only depending on the profiles.
        _getAllParticipantsProfiles(callback);


        /**
         * Resolve all the profiles related to the specified conversation.
         * @param done - a callback that will be executed when all the participants profiles will be resolved.
         */
        function _getAllParticipantsProfiles(done) {
            lpTag.WebAgent.amsUserProfilesController.getUserProfiles({
                users: getAllParticipantsIds(),
                done: done
            });
        }

        function getAllParticipantsIds() {
            var conversationDetails = conversationData.conversationDetails;
            updateDialogParticipantsDetails(conversationDetails);
            var dialogs = conversationDetails && conversationDetails.dialogs;
            var participantsArray = [];

            _.each(dialogs, function (dialog) { // on every dialog
                _.each(dialog.participantsDetails, function (participant) {
                    participantsArray.push(participant.id);
                });
            });
            return _.uniq(participantsArray);
        }

        /**
         *
         * @param conversationDetails
         * adding the (main) dialog a key participantsDetails contains all the conversation participants in the format of {role: CONSUMER/READER/..., id: participantId}.
         */
        function updateDialogParticipantsDetails(conversationDetails) {
            var mainDialog = getMainDialog(conversationDetails);
            if (mainDialog && !mainDialog.participantsDetails) { // that means this conversation is in the old API format
                mainDialog.participantsDetails = [];
                _.each(lpTag.AMSStatics.participant.roles, function (value, key) {
                    var participantsOfRoleArray = conversationDetails.participants[value];
                    if (participantsOfRoleArray && participantsOfRoleArray.length) {
                        _.each(participantsOfRoleArray, function (participantId) {
                            mainDialog.participantsDetails.push({
                                role: value,
                                id: participantId
                            });
                        });
                    }
                });
            }
        }
    }

    function _syncTrackedConversations() {
        // #1: only if we are tracking conversations
        if (trackingList && lpUtils.objectKeysCount(trackingList) > 0) {
            for (var subscriptionId in trackingList) {

                var subscription = this.subscriptions[subscriptionId];
                var conversations = model.get(subscription.settings.modelPath);
                var isDirty = false;

                for (var conversation in conversations) {
                    if (_updateDynamicProperties(subscription.settings, conversations[conversation])) {
                        isDirty = true;
                    }
                }

                if (isDirty) {
                    model.modify(subscription.settings.isDirtyModelPath, true);
                }
            }
        }
    }

    function getMainDialog(conversationDetails) {
        return _.find(conversationDetails.dialogs, function(dialog) { return dialog.dialogType === lpAMSController.DIALOG_TYPES.MAIN; });
    }

    /**
     * Add custom properties to the conversation model, like sla texts and badges that are calculated for the application usage.
     * @param conversationData
     * @private
     */
    function _setCustomProperties(conversationData) {
        // le-40084, fix for the issue when the server sends SLA values when the conversation state is not opened.
        if (conversationData.conversationDetails && conversationData.conversationDetails.state !== lpAMSController.CONVERSATION_STATES.OPEN) {
            conversationData.effectiveTTR = -1;
        }
        var mainDialog = getMainDialog(conversationData.conversationDetails);

        splitToParticipantsSuggested();

        conversationData.consumerId = getParticipantId(mainDialog, lpTag.AMSStatics.participant.roles.CONSUMER);
        conversationData.suggestedAgentId = getSuggestedAgentIdFromSuggestedParticipants();
        conversationData.assignedAgentId = getParticipantId(mainDialog, lpTag.AMSStatics.participant.roles.ASSIGNED_AGENT);
        conversationData.SlaTexts = getTextualSLA(conversationData.effectiveTTR);
        conversationData.badges = getBadges();
        setManualETTR(conversationData.conversationDetails);

        // transfer to agent - remove suggested from conversation participantsDetails
        function splitToParticipantsSuggested() {
            mainDialog.suggestedParticipantsDetails = mainDialog.suggestedParticipantsDetails || formatAsObject(getSuggestedParticipantsDetails());
            if (_.isArray(mainDialog.participantsDetails)) {
                mainDialog.participantsDetails = getOtherParticipantsDetails();
            } else {
                mainDialog.participantsDetails = formatAsObject(getOtherParticipantsDetails());
            }

            function getSuggestedParticipantsDetails() {
                var suggested = _.filter(mainDialog.participantsDetails, { state: lpTag.AMSStatics.assignedAgentState.SUGGESTED });
                return !_.isEmpty(suggested) ? suggested : null;
            }

            function getOtherParticipantsDetails() {
                return _.filter(mainDialog.participantsDetails, function (participant) {
                    return participant.state !== lpTag.AMSStatics.assignedAgentState.SUGGESTED;
                });
            }

            function formatAsObject(data) {
                return _.reduce(data, function (acc, value) {
                    var participantId = _.last((value.id + '').split('.'));
                    acc[participantId] = value;
                    return acc;
                }, {});
            }
        }

        function getSuggestedAgentIdFromSuggestedParticipants() {
            var suggestedAgent = _.find(mainDialog && mainDialog.suggestedParticipantsDetails, { role: lpTag.AMSStatics.participant.roles.ASSIGNED_AGENT });
            return suggestedAgent && suggestedAgent.id;
        }

        // assumes that there is a max of 1 assigned agent and 1 consumer.
        function getParticipantId(dialog, participantType) {
            var participant = _.find(dialog.participantsDetails, function (dialogParticipant) {
                return dialogParticipant.role === participantType;
            });
            return participant && participant.id;
        }

        function getActiveDialog() {
            return _.find(conversationData.conversationDetails.dialogs, function(dialog) { return dialog.state === lpAMSController.CONVERSATION_STATES.OPEN; });
        }

        function getBadges() {
            var ttrType = {
                normal: "NORMAL",
                urgent: "URGENT"
            };
            var badges = {};
            var activeDialog = getActiveDialog();
            badges.first_time = isFirstConversationBadge();
            badges.urgent = isUrgentBadge();
            badges.overdue = isOverdueBadge();
            badges.in_queue = !(!!conversationData.assignedAgentId);
            badges.in_survey = activeDialog && activeDialog.dialogType === lpAMSController.DIALOG_TYPES.POST_SURVEY;
            badges.no_active_dialog = !activeDialog;

            return badges;

            // TODO: add Protections to the internal functions.
            function isFirstConversationBadge() {
                if (conversationData.conversationDetails.firstConversation !== "undefined" && conversationData.conversationDetails.state !== lpTag.AMSStatics.conversation.states.CLOSE) {
                    return conversationData.conversationDetails.firstConversation;
                }
                return false;
            }

            function isUrgentBadge() {
                if (conversationData.conversationDetails.ttr.ttrType !== "undefined" && conversationData.conversationDetails.state !== lpTag.AMSStatics.conversation.states.CLOSE) {
                    return (conversationData.conversationDetails.ttr.ttrType === ttrType.urgent);
                }
                return false;
            }

            // updating the overdue badge
            function isOverdueBadge() {
                if (conversationData && conversationData.SlaTexts) {
                    // TODO: Elior -> Replcae with Date Compare test, more efficent and not based on augmented calculation.
                    return (conversationData.SlaTexts.text.indexOf('-') >= 0) && conversationData.consumerId !== "undefined";
                }
                return false;
            }

        }

        // TODO: we have this in the main ams controller for the time diff, do we marge this?
        function getTextualSLA(timeStamp) {
            var timeDiff = lpTag.WebAgent.amsConnectionController.amsClient && lpTag.WebAgent.amsConnectionController.amsClient.getTimeDiff && lpTag.WebAgent.amsConnectionController.amsClient.getTimeDiff();
            return lpTag.WebAgent.logicController.getSLATextFromTimestamp(timeStamp, timeDiff);
        }

        function setManualETTR(data) {
            if (data && data.manualETTR === null) {
                data.manualETTR = -1;
            }
        }

    }

    function _updateDynamicProperties(subscriptionSettings, conversationData) {
        // save a local copy of the conversation data.
        var oData = lpUtils.cloneObject(conversationData);
        // update the custom properties in the conversation copy.
        _setCustomProperties(oData);

        // check if the data changed, and raise the flag of the dirty.
        var isDirty = hasChanges();

        // if we have changed, we are updating the model to let the logic update inside (badges calculation and sla texts)
        if (isDirty) {
            // modify the model.
            model.set(subscriptionSettings.modelPath + '.' + conversationData.convId, oData);

            if (subscriptionSettings.conversationPostProcessHandlers && _.isFunction(subscriptionSettings.conversationPostProcessHandlers[lpAMSController.NOTIFICATION_TYPES.UPSERT])) {
                // fire the pre process handler
                subscriptionSettings.conversationPostProcessHandlers[lpAMSController.NOTIFICATION_TYPES.UPSERT].call(this, oData);
            }
        }

        return isDirty;

        function hasChanges() {
            // comparing the old sla with the new sla + the overdue badge.
            return (conversationData.badges.overdue !== oData.badges.overdue ||
            conversationData.SlaTexts.text !== oData.SlaTexts.text ||
            conversationData.SlaTexts.almostOverdue !== oData.SlaTexts.almostOverdue);
        }
    }

    return lpAMSSubscriptionsManagerController;

});
